module.exports = __webpack_public_path__ + "static/media/aerowallet.df014e3b.svg";